import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import PopupV3 from '../../Popup/PopupV3';
import { showPopupNew } from '../../../actions/popup-actions';
import { PopupTypes } from '../../../utils/constants';

import styles from './resumePowerConfirmPopUp.scss';

const ResumePowerConfirmPopUp = ({ onCloseClick }) => {
    const dispatch = useDispatch();
    // Read before onCloseClick clears it from the store, then forwarded to the shared Update-CC modal's
    // own deferred onSuccess so the action the member started (e.g. saving a player) finishes once Power
    // is restored (TMS-2338 deliverable 2).
    const deferredOnSuccess = useSelector(
        ({ popups }) => popups?.[`${PopupTypes.POWER_RESUME_CONFIRM_POPUP}OnSuccess`],
    );

    const handleResume = () => {
        onCloseClick();
        // Resume in place — open the Update-Credit-Card modal here instead of navigating to
        // /subscriptions, carrying the deferred action along.
        dispatch(showPopupNew({
            popup: PopupTypes.UPDATE_CC_POPUP,
            onSuccess: deferredOnSuccess,
        }));
    };

    return (
        <PopupV3
            data-testid="modal.power-resume-confirm"
            className={styles.resumePopup}
            isOpen
            noIcon
            title="Resume Your Power Subscription"
            message="This feature is only available with an active Power subscription."
            showConfirmButton
            confirmButtonLabel="Resume"
            onConfirmClick={handleResume}
            showCancelButton
            cancelButtonLabel="Cancel"
            onCancelClick={onCloseClick}
            reverseButtonOrder
        />
    );
};

ResumePowerConfirmPopUp.propTypes = {
    onCloseClick: PropTypes.func.isRequired,
};

export default ResumePowerConfirmPopUp;
